module.exports = __webpack_public_path__ + "static/media/payment.7f4d4105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment.png
// module id = 1580
// module chunks = 0